<div class="ontology-writer-container" [ngClass]="{'left-column-container': valueFormGroup.controls.type.value === ontologyType.ANALOGIC}">
    <div [ngClass]="{'left-column': valueFormGroup.controls.type.value === ontologyType.ANALOGIC}">
        <section class="gnv-form-content">
            <ng-container *ngIf="requestFormGroup.controls.periodicityType.value === periodicityTypes.DATE else intervalBlock">
              <div class="date-range-container">
                <app-date
                  [dateFormControl]="valueFormGroup.controls.dateRanges.controls.startDateTime"
                  [label]="'export-creation.fields.periodic.start-date' | translate"
                ></app-date>
                <app-date
                  [dateFormControl]="valueFormGroup.controls.dateRanges.controls.endDateTime"
                  [label]="'export-creation.fields.periodic.end-date' | translate"
                ></app-date>
              </div>
            </ng-container>

            <ng-template #intervalBlock>
                <app-interval [valueFormControl]="valueFormGroup.controls.interval"></app-interval>
            </ng-template>
            <ng-container *ngIf="valueFormGroup.controls.type.value !== ontologyType.ANALOGIC">
                <ng-container *ngTemplateOutlet="stationView"></ng-container>
            </ng-container>
        </section>

        <ng-container *ngIf="valueFormGroup.controls.type.value === ontologyType.ANALOGIC">
            <section class="gnv-form-content gnv-form-content-func">
                <app-select-analogic-calculation-function-type [valueFormControl]="valueFormGroup.controls.calculationFunctionType"></app-select-analogic-calculation-function-type>
                <ng-container *ngIf="valueFormGroup.controls.calculationFunctionType.value && valueFormGroup.controls.calculationFunctionType.value !== calculationFunctionType.RAW">
                    <app-select-analogic-calculation-interval
                            [valueFormGroup]="valueFormGroup"
                    ></app-select-analogic-calculation-interval>
                </ng-container>
            </section>
        </ng-container>
    </div>

    <ng-container *ngIf="valueFormGroup.controls.type.value === ontologyType.ANALOGIC">
        <section class="gnv-form-content right-column">
            <div class="tags-container">
                <ng-container *ngTemplateOutlet="stationView"></ng-container>
                <ng-container *ngIf="(valueFormGroup.controls.stations.value?.length || 0) > 0">
                    <app-tag-writer
                            [stationUids]="valueFormGroup.controls.stations.value || []"
                            [valueFormGroup]="valueFormGroup"
                    ></app-tag-writer>
                </ng-container>
            </div>
        </section>
    </ng-container>

    <div *ngIf="valueFormGroup.controls.type.value !== ontologyType.ANALOGIC">
        <ng-container *ngIf="valueFormGroup.controls.type.value === ontologyType.STATION_STATE">
            <div class="gnv-form-content-column">
                <app-select-station-sampling [valueFormControl]="valueFormGroup.controls.sampling"></app-select-station-sampling>
                <app-select-station-energy [valueFormControl]="valueFormGroup.controls.energies"></app-select-station-energy>
            </div>
        </ng-container>

        <ng-container *ngIf="valueFormGroup.controls.type.value === ontologyType.TRANSACTION">
            <div class="gnv-form-content-row">
                <app-select-transaction-provider [valueFormControl]="valueFormGroup.controls.provider"></app-select-transaction-provider>
                <app-select-subscriptions [valueFormControl]="valueFormGroup.controls.subscriptions"></app-select-subscriptions>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #stationView>
    <app-select-stations
      [valueFormControl]="valueFormGroup.controls.stations"
      [showAllStationsForm]="valueFormGroup.controls.showAllStations"
    ></app-select-stations>
</ng-template>
